import React from "react";
import type { RouteComponentProps, RouteProps } from "react-router-dom";
import { Route as OriginalRoute, Redirect } from "react-router-dom";
import { ErrorBoundary } from "../ErrorBoundary";

export const Route = <T extends RouteProps = RouteProps>(props: T) => (
  <ErrorBoundary>{() => <OriginalRoute {...props} />}</ErrorBoundary>
);

type RouteWithRedirectProps = Readonly<{
  redirectTo: string;
  queryParams?: ReadonlyDictionary<string>;
}>;

export const RouteWithRedirect = <T extends RouteProps = RouteProps>(
  props: RouteWithRedirectProps & T
) => (
  <Route {...props} render={innerProps => <RedirectWithQueryParams {...innerProps} {...props} />} />
);

const RedirectWithQueryParams = <T extends { [K in keyof T]?: string }>(
  props: RouteComponentProps<T> & RouteWithRedirectProps
) => {
  const updatedQuery = new URLSearchParams(props.location.search);

  if (props.queryParams) {
    for (const [key, value] of Object.entries(props.queryParams)) {
      updatedQuery.append(key, value);
    }
  }

  return (
    <Redirect
      to={{
        pathname: props.redirectTo,
        search: updatedQuery.toString(),
      }}
    />
  );
};
